import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import earn_token from './earn_token.mp3';
import './Coin.scss';

const Coin = (props) => {

    const dispatch = useDispatch();

    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const [coinAudio, setCoinAudio] = useState(false);
    const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');

    const isIOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform);
    };

    useEffect(() => {
        let timer;
        if (coinAudio && isIOS()) {
          timer = setTimeout(() => {
            dispatch({ type: `FREEPLAY_SET_${props.level}_COIN`, payload: props.coin + 1 });
            if(props.level === 'LEVEL2'){
                dispatch({ type: `FREEPLAY_SET_LEVEL2_SHAREDCOIN`, payload: freeplay.level2SharedCoin + 1 });
            }
            if(props.level === 'LEVEL3'){
                dispatch({ type: `FREEPLAY_SET_LEVEL3_SHAREDCOIN`, payload: freeplay.level3SharedCoin + 1 });
            }
            if(props.level === 'LEVEL4'){
                dispatch({ type: `FREEPLAY_SET_LEVEL4_SHAREDCOIN`, payload: freeplay.level4SharedCoin + 1 });
            }
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            props.close();
          }, 3000);
        }
        return () => {
          if (timer) clearTimeout(timer);
        };
      }, [coinAudio]);


    return (
        <div className='coinBody'>
            {coinAudio && (
                <audio
                    autoPlay
                    onEnded={() => {
                    dispatch({ type: `FREEPLAY_SET_${props.level}_COIN`, payload: props.coin + 1 });
                    if(props.level === 'LEVEL2'){
                        dispatch({ type: `FREEPLAY_SET_LEVEL2_SHAREDCOIN`, payload: freeplay.level2SharedCoin + 1 });
                    }
                    if(props.level === 'LEVEL3'){
                        dispatch({ type: `FREEPLAY_SET_LEVEL3_SHAREDCOIN`, payload: freeplay.level3SharedCoin + 1 });
                    }
                    if(props.level === 'LEVEL4'){
                        dispatch({ type: `FREEPLAY_SET_LEVEL4_SHAREDCOIN`, payload: freeplay.level4SharedCoin + 1 });
                    }
                    setCoinAudio(false);
                    setCoinAnimationState('bounceIcons');
                    props.close();
                }}>
                    <source src={earn_token} type='audio/mp3'/>
                </audio>
            )}
            <img
                id={coinAnimationState}
                src={coinPick}
                alt='reward key'
                className='coin'
                onClick={() => {
                    setCoinAnimationState('coinAnimation');
                    setCoinAudio(true);
                }}
            />
        </div>
    );
};
export default Coin;